import React from "react";
import { MainSection } from "components/pachinko/Main";

export interface IPachinkoComponent {}

export const PachinkoComponent: React.FC<IPachinkoComponent> = (): JSX.Element => {
  return (
    <>
      <MainSection />
      {/* <Prizes /> */}
      {/* <Fade triggerOnce>
        <TopTenTableComponent />
      </Fade> */}
      {/* <Fade triggerOnce>
        <TheLiveStream />
      </Fade> */}
    </>
  );
};
